import React, { useState, useEffect } from 'react';

function Confetti() {
  const pieces = Array.from({length:32},(_,i)=>({
    id:i, x:Math.random()*100, delay:Math.random()*1.5,
    color:["#C8A84B","#4AC87A","#7B6FD0","#2ABFCF","#C06090","#D4873A"][i%6],
    size:6+Math.random()*8,
  }));
  return (
    <div style={{position:"fixed",inset:0,pointerEvents:"none",zIndex:500,overflow:"hidden"}}>
      {pieces.map(p=>(
        <div key={p.id} style={{
          position:"absolute", left:`${p.x}%`, top:"-20px",
          width:p.size, height:p.size, borderRadius:p.id%3===0?"50%":"2px",
          background:p.color, opacity:0.9,
          animation:`confettiFall 2.5s ${p.delay}s ease-in forwards`,
        }}/>
      ))}
      <style>{`@keyframes confettiFall{from{transform:translateY(0) rotate(0deg);opacity:1}to{transform:translateY(110vh) rotate(720deg);opacity:0}}`}</style>
    </div>
  );
}

export default Confetti;
